import { useSyncExternalStore } from "react";
import { getOrders } from "../api/orders-api";
let orders = [];
let initialization = null;
const listeners = new Set();
const expirationTimers = new Map();
const notify = () => {
    listeners.forEach((listener) => listener());
};
const subscribe = (listener) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
const getSnapshot = () => orders;
const scheduleExpiration = (order) => {
    const currentTimer = expirationTimers.get(order.id);
    if (currentTimer) {
        clearTimeout(currentTimer);
    }
    const delay = Math.max(0, new Date(order.expiresAt).getTime() - Date.now());
    expirationTimers.set(order.id, setTimeout(() => removeOrder(order.id), delay));
};
export const useOrders = () => useSyncExternalStore(subscribe, getSnapshot);
export const initializeOrders = () => {
    if (!initialization) {
        initialization = getOrders()
            .then((loadedOrders) => {
            orders = loadedOrders;
            orders.forEach(scheduleExpiration);
            notify();
        })
            .catch((error) => {
            initialization = null;
            throw error;
        });
    }
    return initialization;
};
export const addOrder = (order) => {
    orders = [...orders.filter((item) => item.id !== order.id), order];
    scheduleExpiration(order);
    notify();
};
export const removeOrder = (orderId) => {
    const timer = expirationTimers.get(orderId);
    if (timer) {
        clearTimeout(timer);
        expirationTimers.delete(orderId);
    }
    orders = orders.filter((order) => order.id !== orderId);
    notify();
};
